<template>
  <div
    class="flex items-center justify-between px-4 my-4 rounded-sm cursor-pointer hover:bg-i4m-grey-light"
  >
    <svgicon name="telephone" original :width="size" :height="size"></svgicon>
    <a
      href="teL:+3903721786523"
      class="ml-1 text-xs font-bold md:ml-4 text-i4m-blue md:text-xl lg:text-2xl"
    >
      0372 178 65 23
    </a>
  </div>
</template>

<script>
export default {
  name: 'telephone-cta',

  props: {
    mobile: {
      type: Boolean
    }
  },

  computed: {
    size() {
      return this.mobile ? '20' : '32';
    }
  },
  data() {
    return {};
  }
};
</script>
